import React from 'react';
import { useAppSelector } from '~redux/hooks';
import GoldInventoryExportPDF from './ExportPDF';

const InventoryDeliveredPDF = () => {
    const inventoryDeliveredListing = useAppSelector((state) => state.gold.goldInventoryReport.inventoryDelivered.data);

    return (
        <div>
            <GoldInventoryExportPDF
                inventoryDeliveredListing={inventoryDeliveredListing}
            />
        </div>
    );
};

export default InventoryDeliveredPDF;
